/**
 * Wishlist toggle — Swym Wishlist Plus SDK.
 * Buttons: .js-wishlist-btn (PDP ATC pill + product cards)
 */
(function () {
  'use strict';

  var READY_ATTR = 'data-wishlist-ready';

  function buildProductFromPageData(pageData) {
    return {
      epi: pageData.epi,
      empi: pageData.empi,
      du: pageData.du,
      dt: pageData.dt,
      iu: pageData.iu,
      pr: pageData.pr
    };
  }

  function buildProductFromButton(btn) {
    var productId = Number(btn.getAttribute('data-product-id'));
    var variantId = Number(btn.getAttribute('data-variant-id'));
    var price = parseFloat(btn.getAttribute('data-product-price'));

    return {
      epi: variantId,
      empi: productId,
      du: btn.getAttribute('data-product-url') || window.location.href,
      dt: btn.getAttribute('data-product-title') || '',
      iu: btn.getAttribute('data-product-image') || '',
      pr: isNaN(price) ? undefined : price
    };
  }

  function updateButtonState(btn, isWishlisted) {
    if (!btn) return;
    var addLabel = btn.getAttribute('data-add-label') || 'Add to wishlist';
    var removeLabel = btn.getAttribute('data-remove-label') || 'Remove from wishlist';
    btn.classList.toggle('swym-added', isWishlisted);
    btn.setAttribute('aria-pressed', isWishlisted ? 'true' : 'false');
    btn.setAttribute('aria-label', isWishlisted ? removeLabel : addLabel);
  }

  function checkState(swat, btn, product) {
    swat.fetch(function (wishlisted) {
      var found = (wishlisted || []).some(function (item) {
        return item.empi === product.empi && item.epi === product.epi;
      });
      updateButtonState(btn, found);
    });
  }

  function syncVariant(product, variantId) {
    if (!variantId) return;
    var info = window.SwymProductVariants && window.SwymProductVariants[variantId];
    if (info) {
      product.epi = info.epi;
      if (info.pr != null) product.pr = info.pr;
      if (info.iu) product.iu = info.iu;
    } else {
      product.epi = variantId;
    }
  }

  function resolveProduct(btn) {
    var pageData = window.SwymPageData;
    var productId = Number(btn.getAttribute('data-product-id'));
    var isPdpBtn = btn.id === 'pdp-wishlist-btn';

    if (isPdpBtn && pageData && pageData.et === 1 && pageData.empi === productId) {
      return buildProductFromPageData(pageData);
    }

    return buildProductFromButton(btn);
  }

  function bindButton(swat, btn) {
    if (btn.getAttribute(READY_ATTR)) return;
    btn.setAttribute(READY_ATTR, 'true');

    var product = resolveProduct(btn);
    var isPdpBtn = btn.id === 'pdp-wishlist-btn';

    if (isPdpBtn) {
      var form = btn.closest('form');
      var variantInput = form
        ? form.querySelector('[name="id"]')
        : document.querySelector('product-form [name="id"], form[action*="/cart/add"] [name="id"]');

      if (variantInput && variantInput.value) {
        syncVariant(product, Number(variantInput.value));
      }
    }

    checkState(swat, btn, product);

    btn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (btn.disabled) return;
      btn.disabled = true;

      var done = function () {
        btn.disabled = false;
      };

      if (btn.classList.contains('swym-added')) {
        swat.removeFromWishList(product, function () {
          updateButtonState(btn, false);
          done();
        });
      } else {
        swat.addToWishList(product, function () {
          updateButtonState(btn, true);
          done();
        });
      }
    });

    if (!isPdpBtn) return;

    if (swat.evtLayer && swat.JSEvents && swat.JSEvents.variantChanged) {
      swat.evtLayer.addEventListener(swat.JSEvents.variantChanged, function (evt) {
        var variantData = evt && evt.detail && evt.detail.d;
        var newVariantId = variantData && variantData.variant && variantData.variant.id;
        if (!newVariantId) return;
        syncVariant(product, newVariantId);
        checkState(swat, btn, product);
      });
    }

    document.addEventListener('variant:change', function (event) {
      var detail = event.detail || {};
      var variant = detail.variant;
      var newVariantId = variant && variant.id;
      if (!newVariantId) return;
      syncVariant(product, newVariantId);
      checkState(swat, btn, product);
    });
  }

  function bindAll(swat) {
    document.querySelectorAll('.js-wishlist-btn').forEach(function (btn) {
      bindButton(swat, btn);
    });
  }

  function initWishlistButtons(swat) {
    bindAll(swat);

    if (typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function () {
      bindAll(swat);
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(initWishlistButtons);
})();
